module.exports = __webpack_public_path__ + "img/female.8e19953e.png";